module.exports = __webpack_public_path__ + "img/b12.a75bacb2.jpeg";